import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
const COGNITO_KEY = '9LE9gkNsKEqE0uCOyZZkrw';
export const CognitoForm = (props)=>{
    const formRef = useRef(null);
    const script = useRef(false);
    const onFormInit = ()=>{
        if (window.Cognito && formRef.current) {
            window.Cognito.mount(props.id.toString(), formRef.current).prefill(props.prefillData || {});
        }
    };
    const onLoadScript = ()=>{
        const scriptElem = document.createElement('script');
        scriptElem.src = 'https://www.cognitoforms.com/f/seamless.js';
        scriptElem.type = 'text/javascript';
        scriptElem.async = false;
        scriptElem.setAttribute('data-key', COGNITO_KEY);
        scriptElem.setAttribute('data-form', props.id.toString());
        scriptElem.onload = ()=>{
            script.current = true;
            onFormInit();
        };
        document.getElementsByTagName('head')[0].appendChild(scriptElem);
    };
    useEffect(()=>{
        const existingScript = document.querySelector(`script[data-key="${COGNITO_KEY}"]`);
        if (existingScript) {
            script.current = true;
            onFormInit();
        } else {
            onLoadScript();
        }
        return ()=>{
            if (formRef.current && window.Cognito) {
                try {
                    window.Cognito.unmount(formRef.current);
                } catch (e) {
                    console.error('Error unmounting Cognito form:', e);
                }
            }
        };
    }, [
        props.id
    ]);
    useEffect(()=>{
        if (script.current && window.Cognito && props.prefillData) {
            onFormInit();
        }
    }, [
        props.prefillData
    ]);
    return /*#__PURE__*/ _jsx("div", {
        id: "cognito",
        ref: formRef
    });
};
CognitoForm.displayName = 'CognitoForm';

//# sourceMappingURL=CognitoForm.js.map